import { useState } from "react";
import { api } from "@/api/client";

/**
 * Local development login (LC_AUTH_MODE=dev). In production the backend redirects
 * to KOPER SSO and this screen is never reached — /api/auth/dev-login returns 404.
 */
export function DevLogin({ onLoggedIn }: { onLoggedIn: () => Promise<void> }) {
  const [name, setName] = useState("Анна");
  const [role, setRole] = useState("admin");
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    setErr(null);
    try {
      await api.devLogin(name, [role]);
      await onLoggedIn();
    } catch {
      // dev-login disabled => real SSO is configured; bounce to it.
      window.location.href = "/api/auth/login";
    }
  };

  return (
    <div className="center">
      <div className="card" style={{ padding: 28, width: 360, textAlign: "left" }}>
        <div className="brand" style={{ marginBottom: 14 }}>
          <span className="mk">🌐</span>Сайты маркетинга
        </div>
        <p className="muted small" style={{ marginTop: 0 }}>
          Вход для разработки. На проде здесь будет вход через KOPER.
        </p>
        <div className="frm">
          <div className="field">
            <label>Имя</label>
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="field">
            <label>Роль</label>
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value="admin">Администратор (ТД/ОД/Верховный/ДОМ)</option>
              <option value="publisher">Публикация (прод)</option>
              <option value="operator">Оператор — тест + пауза (МОМ)</option>
              <option value="deploy:test">Только тест</option>
              <option value="viewer">Просмотр</option>
            </select>
          </div>
          {err && <div className="err">{err}</div>}
          <button className="btn primary big" onClick={submit}>
            Войти
          </button>
        </div>
      </div>
    </div>
  );
}
